export default __webpack_public_path__ + "media/zurb/img/home/home-section-1-bg-678956c72e06febfe66296b9cae3b93c.png";